import Vue from 'vue'
import Router from 'vue-router'

// 一级
import login from '@/views/login' //登录
import home from '@/views/home' //首页
import zyf from '@/views/information/college' //院校资源
import newList from '@/views/news/newsList' //高考资讯
import zhuanyezhiyuan from '@/views/information/major' //专业资源
import jobzhiyuan from '@/views/information/job' //专业资源
import Vip from '@/views/Vip' //vip
import tiaobaozhiyuan from '@/views/tianbao/tiaobaozhiyuan' //填报志愿
import selectzhuanye from '@/views/tianbaoList/selectzhuanye' //专业优先


// 二级文章详情
import newsDetail from '@/views/news/newsDetail'

// 个人中心
import gerenzhongxin from '@/views/mine/a_userinfo' //基本资料
import grzx_wdfs from '@/views/mine/b_wdfenshu' //我的分数
import grzx_wdxs from '@/views/mine/c_wdxuesheng' //我的学生
import grzx_shouchangxueyuan from '@/views/mine/d_scyuanxiao' //收藏院校
import grzx_chouchangzhuanye from '@/views/mine/e_sczhuanye' //收藏专业
import grzx_wodeguanzhu from '@/views/mine/f_wdguanzhu' //我的关注
import wodexuankewai from '@/views/mine/g_wdxuanke' //我的选科
import grzx_wodexuanke from '@/views/mine/g_wdxuanke1'
import zhinengxuanke from '@/views/mine/g_zhinengxuanke'
import xuankefangan_zyqkdcb from '@/views/mine/g_xuankefangan_zyqkdcb' // 选课方案及匹配专业情况表查看详情页
import xuankeqingkuangcaxunye from '@/views/mine/g_xuankeqingkuangcaxunye' // 选科情况查询页
import zhinengxuankejieguoye from '@/views/mine/g_zhinengxuankejieguoye' //智能选科结果页

import grzx_xinggeceping from '@/views/mine/h_wdceping' //测评
import grzx_cepingjieguo from '@/views/mine/h_wdceping1'
import kaishicheping from '@/views/mine/h_startcheping' // 开始测评
import tcphistory from '@/views/mine/h_cphistory'
import grzx_xinggeceping2 from '@/views/mine/h_wdceping_result2'
import grzx_xinggeceping_result from '@/views/mine/h_wdceping_result'

import grzx_wodezhiyuan from '@/views/mine/i_wdzhiyuan' // 优化志愿报告单
import grzx_yhzybgd_lao from '@/views/mine/i_zyd_lao' //志愿单
import grzx_xougaimima from '@/views/mine/j_updatepwd' //修改密码
import grzx_scorerank from '@/views/mine/k_scorerank' //修改密码









// 校园资源
import xyzy_jianjie from '@/views/information/collegeinfo/xyzy_jianjie.vue' //院校简介


// 咋乱
import yuanxiaofen from '@/views/yuanxiaofen' //院校分
import cegailv from '@/views/cegailv' //录取概率
import zhuanyefen from '@/views/zhuanyefen' //专业分
// import newgaokao from '@/views/newgaokao' //暂时不用
import zyd from '@/views/tianbao/zyd' //志愿单


// 新加
import zhuan_newgaokao from '@/views/tianbaoList/zhuan_newgaokao' //志愿选择

import xuanzheyuanhuoye from '@/views/tianbao/xuanzheyuanhuoye' //志愿填报类型   院校填报或专业填报
import yijiantianbao from '@/views/yijiantianbao' //一件填报


import zyxq_zhuanyejieshao from '@/views/information/majorinfo/zyxq_zhuanyejieshao' // 专业详情


Vue.use(Router)


//解决vue路由重复导航错误
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    // 咋乱
    {
      path: '/yuanxiaofen',
      name: 'yuanxiaofen',
      component: yuanxiaofen
    },
    {
      path: '/cegailv',
      name: 'cegailv',
      component: cegailv
    },

    {
      path: '/zhuanyefen',
      name: 'zhuanyefen',
      component: zhuanyefen
    },

    {
      //志愿填报内容
      path: '/zhuan_newgaokao',
      name: 'zhuan_newgaokao',
      component: zhuan_newgaokao
    },
    {
      //填报类型选择
      path: '/xuanzheyuanhuoye',
      name: 'xuanzheyuanhuoye',
      component: xuanzheyuanhuoye
    },
    {
      path: '/yijiantianbao',
      name: 'yijiantianbao',
      component: yijiantianbao
    }, {
      path: '/zyd',
      name: 'zyd',
      component: zyd
    },

    // 一级
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/home',
      name: 'home',
      component: home
    },

    {
      path: '/zyf',
      name: 'zyf',
      component: zyf,
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/newListgkzx',
      name: 'newListgkzx',
      component: newList
    },
    {
      path: '/newListlbxw',
      name: 'newListlbxw',
      component: newList
    },
    {
      path: '/newListksbd',
      name: 'newListksbd',
      component: newList
    },
    {
      path: '/newListyszs',
      name: 'newListyszs',
      component: newList
    },
    {
      path: '/newListkswd',
      name: 'newListkswd',
      component: newList
    },
    {
      path: '/newListspzs',
      name: 'newListspzs',
      component: newList
    },
    {
      path: '/newListsyxw',
      name: 'newListsyxw',
      component: newList
    },
    {
      path: '/newListzygl',
      name: 'newListzygl',
      component: newList
    },
    //暂时不用
    // {
    //   path: '/newgaokao',
    //   name: 'newgaokao',
    //   component: newgaokao
    // },
    {
      //专业信息
      path: '/zhuanyezhiyuan',
      name: 'zhuanyezhiyuan',
      component: zhuanyezhiyuan
    },
    {
      //专业信息
      path: '/jobzhiyuan',
      name: 'jobzhiyuan',
      component: jobzhiyuan
    },
    {
      path: '/Vip',
      name: 'Vip',
      component: Vip
    },
    {
      //省控线选择
      path: '/tiaobaozhiyuan',
      name: 'tiaobaozhiyuan',
      component: tiaobaozhiyuan
    },
    {
      // 专业填报选择专业
      path: '/zhiyuanList_zyselect',
      name: 'zhiyuanList_zyselect',
      component: selectzhuanye
    },



    // 二级文章详情
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: newsDetail
    },

    // 个人中心
    {
      path: '/gerenzhongxin',
      name: 'gerenzhongxin',
      component: gerenzhongxin
    }, {
      path: '/grzx_wdfs',
      name: 'grzx_wdfs',
      component: grzx_wdfs
    }, {
      path: '/grzx_wdxs',
      name: 'grzx_wdxs',
      component: grzx_wdxs
    }, {
      path: '/grzx_chouchangzhuanye',
      name: 'grzx_chouchangzhuanye',
      component: grzx_chouchangzhuanye
    }, {
      path: '/grzx_shouchangxueyuan',
      name: 'grzx_shouchangxueyuan',
      component: grzx_shouchangxueyuan
    }, {
      path: '/grzx_wodeguanzhu',
      name: 'grzx_wodeguanzhu',
      component: grzx_wodeguanzhu
    }, {
      path: '/grzx_wodezhiyuan',
      name: 'grzx_wodezhiyuan',
      component: grzx_wodezhiyuan
    }, {
      path: '/grzx_xougaimima',
      name: 'grzx_xougaimima',
      component: grzx_xougaimima
    }, {
      path: '/grzx_scorerank',
      name: 'grzx_scorerank',
      component: grzx_scorerank
    },
    {
      //志愿单详情
      path: '/grzx_yhzybgd_lao',
      name: 'grzx_yhzybgd_lao',
      component: grzx_yhzybgd_lao
    },
    {
      path: '/grzx_xinggeceping',
      name: 'grzx_xinggeceping',
      component: grzx_xinggeceping
    },
    {
      path: '/tcphistory',
      name: 'tcphistory',
      component: tcphistory
    },
    {
      path: '/grzx_xinggeceping2',
      name: 'grzx_xinggeceping2',
      component: grzx_xinggeceping2
    },
    {
      path: '/grzx_xinggeceping_result',
      name: 'grzx_xinggeceping_result',
      component: grzx_xinggeceping_result
    },
    {
      path: '/grzx_wodexuanke',
      name: 'grzx_wodexuanke',
      component: grzx_wodexuanke
    },
    {
      path: '/grzx_cepingjieguo',
      name: 'grzx_cepingjieguo',
      component: grzx_cepingjieguo
    },
    {
      path: '/wodexuankewai',
      name: 'wodexuankewai',
      component: wodexuankewai
    },
    {
      path: '/zhinengxuanke',
      name: 'zhinengxuanke',
      component: zhinengxuanke
    },
    {
      // 选课方案及匹配专业情况表查看详情页
      path: '/xuankefangan_zyqkdcb',
      name: 'xuankefangan_zyqkdcb',
      component: xuankefangan_zyqkdcb
    },
    {
      // 选科情况查询页
      path: '/xuankeqingkuangcaxunye',
      name: 'xuankeqingkuangcaxunye',
      component: xuankeqingkuangcaxunye
    },
    {
      // 智能选科结果页
      path: '/zhinengxuankejieguoye',
      name: 'zhinengxuankejieguoye',
      component: zhinengxuankejieguoye
    },
    {
      // 开始测评
      path: '/kaishicheping',
      name: 'kaishicheping',
      component: kaishicheping
    },




    // 校园资源
    {
      path: '/xyzy_jianjie',
      name: 'xyzy_jianjie',
      component: xyzy_jianjie
    },


    // 专业详情
    {
      path: '/zyxq_zhuanyejieshao',
      name: 'zyxq_zhuanyejieshao',
      component: zyxq_zhuanyejieshao
    },

  ],

})



// WEBPACK FOOTER //
// ./src/router/index.js